import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {Field, getFormValues, reduxForm} from 'redux-form';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import SearchIcon from '@mui/icons-material/Search';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import {withStyles} from '@mui/styles';
import Typography from '@mui/material/Typography';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import {} from '@mui/lab';
import {searchMap, searchCheck} from '../../../../common/common.js';
import CustomFlexGrid, {createComponents} from '../../../molecules/CustomFlexGrid.js';
import {getKbnList, sysErr} from '../../../../common/commonGmn.js';
import {CATEGORY_TYPE} from '../../../../common/commonConst.js';
import {commonOperations} from '../../../../reducks/common';
import {renderSelect, renderTextField} from '../../../atoms/CustomPart.js';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
import {PositiveButton} from '../../../atoms/Buttons/PositiveButton.js';
import PaperPart from '../../../atoms/PaperPart.js';
import withRouter from '../../../organisms/withRouter.js';
import Modal from '@mui/material/Modal';
import {HttpStatusCode} from 'axios';
import {postRequest} from '../../../../common/backend.js';
import WarningMessageArea from '../../../molecules/WarningMessageArea.js';
const styles = (theme) => ({
  content: {
    'flexGrow': 1,
    'overflow': 'auto',
    'max-height': 'calc(100vh - 75px - 62px)',
    'height': 'auto',
    'padding': '7px 0 15px',
    'marginTop': '62px',
    'background': '#f5f5f5',
  },
  button: {
    margin: '15px 10px 5px 10px',
  },
  fields: {
    'margin': '0px 10px 15px 10px',
  },
});

// 区画選択
const blockNoListViews = [
  {binding: 'oldNwOfficeCode', header: 'NW事業所', dataType: 'String', width: 1, isReadOnly: true, visible: false},
  {binding: 'blockNo', header: '区画番号', dataType: 'String', width: 100, isReadOnly: true},
  {binding: 'lastSurveyFiscalYear', header: '前回調査年度', dataType: 'String', width: 130, isReadOnly: true},
  {binding: 'nextSurveyFiscalYear', header: '次回調査年度', dataType: 'String', width: 130, isReadOnly: true},
  {binding: 'lastSurveyCheckConsignArea', header: '前回委託エリア', dataType: 'String', width: 150, isReadOnly: true},
  {binding: 'nextSurveyCheckConsignArea', header: '次回委託エリア', dataType: 'String', width: 150, isReadOnly: true},
];

/**
 * 区画選択
 * 画面ID:SCI1003
 */
class Container extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      buttonDisabled: true,
    };

    this.gridRef = React.createRef();
    this.filteredList=[];
  }

  /**
   * 初期処理
   */
  async componentDidMount() {
    this._initialValue();
  }
  /**
     * 画面項目初期化
     */
  _initialValue = async () => {
    const {userInfo, selectNwOfficeCode} = this.props;
    try {
      let valid = userInfo.authNwOfficeCodes?.includes(selectNwOfficeCode);
      let nwOfficeCode = valid ? selectNwOfficeCode : null;
      this.props.change('kyuNwOffice', nwOfficeCode);
      this.setState({
        warningMessages: [],
      });
    } catch (error) {
      sysErr(this.props);
    }
  };

  /**
     * 終了処理
     */
  async componentWillUnmount() {
    this.props.reset();
  }

  /**
   * クリア処理
   */
  _reset = async () => {
    await this.props.reset();
    this._initialValue();
    this.gridRef.current.setItemsSource([]);
  };

  /**
   * 検索ボタン押下時処理
   * @param {bool} show
   */
  doSearch = async () => {
    try {
      const {values, userInfo} = this.props;
      let searchNwCodes = [];
      if (values.nwOfficeCode == null||values.nwOfficeCode == '') {
        searchNwCodes=userInfo.authNwOfficeCodes;
      } else {
        searchNwCodes=[values.nwOfficeCode];
      }
      let _body = {
        searchConditionModel: values,
        // 権限todo
        surveyCompanyCode: userInfo.corpCd,
        nwOfficeCodes: searchNwCodes,
      };

      // リクエスト出す
      let _url = 'sci1003/search-block-no-list';
      const response = await postRequest(_url, _body);
      if (response.status != HttpStatusCode.Ok) {
        if (response.data?.message != null) {
          this.props.doShowMessage({
            message: {id: response.data?.message.id,
              text: response.data?.message.text},
          });
        }
        return;
      }
      // 件数チェック
      let _warningMessages = searchCheck(response.data.blockNoList);
      this.setState({warningMessages: _warningMessages});

      if (this.gridRef?.current) {
        this.gridRef.current.setItemsSource(
            response.data.blockNoList);
      }
    } catch (error) {
      sysErr(this.props);
    }
  };
  /**
  * ボタンの活性、非活性化
  */
  checkStateUpdate = () => {
    try {
      let bRet = false;

      if (this.gridRef && this.gridRef.current &&
        this.gridRef.current.selectedItemCount() > 0) {
        bRet = true;
      }

      if (bRet) {
        this.setState({buttonDisabled: false});
      } else {
        this.setState({buttonDisabled: true});
      }
    } catch (error) {
      sysErr(this.props);
    }
  };


  /**
   * 一覧表示
   * @return {object}
   */
  renderTable() {
    const props = {
      rowHeaderType: 'check',
      filterOn: true,
      headersVisibility: 'All',
      allowDragging: 'Columns',
      allowSorting: 'SingleColumn',
      AddDeleteOn: false,
      style: {maxHeight: '300px', maxWidth: '1250px', height: 'auto', width: 'auto'},
      isReadOnly: true,
      isDisplayCount: true,
      checkedFunction: this.checkStateUpdate,
    };

    const component = createComponents(blockNoListViews);
    return (
      <CustomFlexGrid ref={this.gridRef} {...props}>
        {component}
      </CustomFlexGrid>
    );
  }

  /**
   * 戻る
   */
  doBack = () => {
    this.props.closeButton();
  };

  /**
   * 戻る
   */
  doSelect = () => {
    let gridData = this.gridRef.current.selectedItem();
    this.props.selectButton(gridData);
  };

  render() {
    const {classes,
      genericMap,
      handleSubmit,
      userInfo,
    } = this.props;
    const nwOfficeList = searchMap(genericMap, CATEGORY_TYPE.NW_OFFICE_CODE);
    this.filteredList = nwOfficeList.filter(
        (item) => userInfo.authNwOfficeCodes.includes(item.cd));
    let nwOfficeSelectList = getKbnList(this.filteredList);
    const surveyAreaList = searchMap(
        genericMap, CATEGORY_TYPE.SURVEY_CHECK_CONSIGN_AREA_CODE);
    let surveyAreaSelectList = getKbnList(surveyAreaList);
    return (
      <Modal
        open={this.props.modalOpen}
        style={{
          maxWidth: 1000,
          marginLeft: 'auto',
          marginRight: 'auto',
          overflow: 'visible',
        }}
      >
        <form noValidate autoComplete="off" className={classes.root}>
          <Grid key="keySCI1003Msg" item xs={12}>
            <WarningMessageArea messages={this.state.warningMessages} />
          </Grid>
          <PaperPart className={classes.content}>
            <PaperPart>
              <Grid
                container
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={1}
                direction={'row'}
              >
                <Grid key="kyuNwOffice" item xs={12} sm={2}>
                  <Field
                    id="kyuNwOffice"
                    name="kyuNwOffice"
                    component={renderSelect}
                    className={classes.fields}
                    label="旧NW事業所"
                    fullWidth
                    required={false}
                    validate={[
                    ]}
                  >
                    {nwOfficeSelectList}
                  </Field>
                </Grid>
                <Grid key="blockNoFrom" item xs={12} sm={2}>
                  <Field
                    id="blockNoFrom"
                    accessibilitylabel="blockNoFrom"
                    label="区画番号"
                    name="blockNoFrom"
                    component={renderTextField}
                    className={classes.fields}
                    type="text"
                    validate={[
                    ]}
                  />

                </Grid>
                <Typography sx={{margin: '18px 0px 25px 0px'}}>
              ～
                </Typography>
                <Grid key="blockNoTo" item xs={12} sm={2}>
                  <Field
                    id="blockNoTo"
                    name="blockNoTo"
                    label="区画番号"
                    component={renderTextField}
                    className={classes.fields}
                    type="text"
                    validate={[
                    ]}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={1}
              >
                <Grid key="nextSurveyFiscalYear" item xs={12} sm={2}>
                  <Field
                    id="nextSurveyFiscalYear"
                    name="nextSurveyFiscalYear"
                    component={renderTextField}
                    className={classes.fields}
                    label="次回調査年度"
                    fullWidth
                    type="text"
                    required={false}
                    validate={[
                    ]}
                  />
                </Grid>
                <Grid key="surveyCheckConsignAreaCode" item xs={12} sm={4}>
                  <Field
                    id="surveyCheckConsignAreaCode"
                    name="surveyCheckConsignAreaCode"
                    component={renderSelect}
                    className={classes.fields}
                    label="調査点検委託エリア"
                    fullWidth
                    required={false}
                    validate={[
                    ]}
                    InputProps={{
                      readOnly: false,
                    }}
                  >
                    {surveyAreaSelectList}
                  </Field>
                </Grid>
              </Grid>
              <Grid
                container
                justifyContent="right"
                alignItems="right"
                spacing={1}
              >
                <Grid key="clear" item>
                  <NegativeButton
                    id="clear"
                    variant="contained"
                    startIcon={<RotateLeftIcon />}
                    className={classes.button}
                    onClick={handleSubmit(this._reset)}
                  >
                    <span>クリア</span>
                  </NegativeButton>
                </Grid>
                <Grid key="search" item>
                  <PositiveButton
                    id="search"
                    variant="contained"
                    startIcon={<SearchIcon />}
                    className={clsx(classes.button)}
                    onClick={handleSubmit(this.doSearch)}
                  >
                    <span>検索</span>
                  </PositiveButton>
                </Grid>
              </Grid>
            </PaperPart>
            <div style={{marginBottom: '20px'}} />
            <Divider variant="middle" />
            <div style={{marginBottom: '0px'}} />
            <Grid container
              justifyContent="flex-start"
              alignItems="flex-start"
            >
              <Grid key="keySCI1003List" item xs={12} style={{marginTop: '20px'}}>
                {this.renderTable()}
              </Grid>
            </Grid>
            <Grid key="keySCI1003Footer" item xs={12} style={{marginTop: '-20px'}}>
              <Grid
                container
                justifyContent="center"
                alignItems="flex-start"
                spacing={1}
              >
                <Grid key="keySCI1003select" item>
                  <PositiveButton
                    id="keySCI1003select"
                    variant="contained"
                    className={clsx(classes.button)}
                    disabled={this.state.buttonDisabled}
                    onClick={handleSubmit(this.doSelect)}
                  >
                    <span>選択</span>
                  </PositiveButton>
                </Grid>
                <Grid key="keySCI1003close" item>
                  <NegativeButton
                    id="keySCI1003close"
                    variant="contained"
                    className={clsx(classes.button)}
                    startIcon={<KeyboardReturnIcon />}
                    onClick={handleSubmit(this.doBack)}
                  >
                    <span>閉じる</span>
                  </NegativeButton>
                </Grid>
              </Grid>
            </Grid>
          </PaperPart>
        </form>
      </Modal>
    );
  }
}

Container.propTypes = {
  classes: PropTypes.object,
  genericMap: PropTypes.object,
  values: PropTypes.object,
  userInfo: PropTypes.object,
  reset: PropTypes.func,
  handleSubmit: PropTypes.func,
  doShowMessage: PropTypes.func,
  doSetInitValues: PropTypes.func,
  navigate: PropTypes.func,
  modalOpen: PropTypes.bool.isRequired,
  closeButton: PropTypes.func.isRequired,
  selectButton: PropTypes.func.isRequired,
  change: PropTypes.object,
  selectNwOfficeCode: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    genericMap: state.common.generalPurposeMap,
    userInfo: state.auth.userInfo,
    initialValues: state.common.setInitValues,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doSetInitValues: commonOperations.doSetInitValues,
};

const FORM_NAME = 'SCI1003FORM';

Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Container));

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Container)),
);
